import type { SupraSystemSubscriptionType } from '@bb/domain/dist/types/SupraSystemSubscription';
import type { UserSubRoles } from '@bb/users';
import axios from 'axios';

export type SupraSubscriptionOptionsType = {
  keyTypes: SupraSystemSubscriptionType[];
  limitedSubRoles: UserSubRoles[];
  limitedOtherBilling: ('billable' | 'non-billable')[];
  managedAccessSubRoles: UserSubRoles[];
};

type ISubscriptionOptionsResponseType = SupraSubscriptionOptionsType;

const getSubscriptionOptionsForOrg = async () => {
  const { data } = await axios.get<ISubscriptionOptionsResponseType>(
    `/supra/org_subscription_options`,
  );

  return data;
};

export default getSubscriptionOptionsForOrg;
